













































import { defineComponent, ref, watch } from "@vue/composition-api";
import useUserSettings from "@/store/useUserSettings";
import UserSettingsViewModel from "@/models/UserSettingsViewModel";

export default defineComponent({
    name: "EditCurrentDialog",
    components: {
        ConfirmDialog: () => import("../Dialogs/ConfirmDialog.vue"),
    },
    props: { value: { type: Boolean, default: false } },
    setup(props, context) {
        const { getUserSettings, updateUserSettings } = useUserSettings();

        // Full reactive shape from the start (Vue 2 reactivity)
        const model = ref<UserSettingsViewModel>({
            email: "",
            digitalOutputNickname: "Digital Output",
            gasThreshold: 600,
            bilgeThreshold: 1, // default 1 A
            timezone: "Europe/Copenhagen",
            insertedDate: "",
            modifiedDate: ""
        });

        const showSuccess = ref(false);
        const ready = ref(false);

        async function load() {
            ready.value = false;
            try {
                const val = await getUserSettings();
                // Replace whole object to ensure reactivity; coerce number
                model.value = {
                    ...model.value,
                    ...val,
                    bilgeThreshold: Number(val?.bilgeThreshold ?? 1)
                };
                if (!isFinite(model.value.bilgeThreshold)) model.value.bilgeThreshold = 1;
            } finally {
                ready.value = true;
            }
        }

        // Load fresh data whenever the dialog is opened (profile-style timing)
        watch(() => props.value, (open) => { if (open) load(); }, { immediate: true });

        const initSave = async () => {
            // Ensure numeric before persisting
            model.value.bilgeThreshold = Number(model.value.bilgeThreshold ?? 1);
            await updateUserSettings(model.value);
            showSuccess.value = true;
            close();
            context.emit("OnSaveCurrentThreshold", { ...model.value });
        };

        const close = () => {
            context.emit("input", false);
            context.emit("OnCancel");
        };

        const successOk = () => { showSuccess.value = false; };

        return {
            model,
            ready,
            showSuccess,
            initSave,
            close,
            successOk
        };
    }
});
